export default "__VITE_ASSET__Cyqshb8V__";